/**
 * Takes an input and formats it for display in a table.
 * @param {string} input
 */
export const formatTableNumber = (input?: string): number => {
    if (input === undefined || input?.length === 0) {
        return 0;
    }

    const parsed = parseFloat(input);

    if (Number.isNaN(parsed)) {
        return 0;
    }

    return parsed;
};
